// composables/useImpersonation.ts
import { useQueryClient } from '@tanstack/vue-query';
import type { User } from '~/types';
import { USER_ROLES } from '~/constants/auth';

export const useImpersonation = () => {
  const authStore = useAuthStore();
  const queryClient = useQueryClient();

  // Start viewing-as an agent, then land on their dashboard.
  const viewAsAgent = async (agentUserId: string) => {
    const res = await $fetch<{ success: boolean; data: { token: string; user: User } }>('/api/impersonation/start', {
      method: 'POST',
      headers: { Authorization: `Bearer ${authStore.token}` },
      body: { agentUserId },
    });
    authStore.startImpersonation(res.data.token, res.data.user);
    // Drop the cache so the SPA nav can't flash admin-identity data on the agent
    // view (queries refetch under the agent token). Mirrors useSuccessfulLogout.
    queryClient.clear();
    await navigateTo('/dashboard');
  };

  // Exit and return to the admin/AM agent list.
  const exitImpersonation = async () => {
    const back = authStore.impersonatorUser?.role === USER_ROLES.ADMIN ? '/admin/agents' : '/am/agents';
    authStore.stopImpersonation();
    // Clear again so no agent-identity data lingers into the admin view.
    queryClient.clear();
    await navigateTo(back);
  };

  return { viewAsAgent, exitImpersonation };
};
